import React from 'react'
import { IConcept } from '@cbgms/api/modules/concepts'
import { useShopConcept } from './use-shop-concept'

export const ConceptContext = React.createContext<IConcept | null | undefined>(null)

interface Props {
  children: React.ReactNode
  conceptUUID: string
}

export function ConceptContextProvider(props: Props) {
  const shopConcept = useShopConcept({ conceptUUID: props.conceptUUID })
  return <ConceptContext.Provider value={shopConcept}>{props.children}</ConceptContext.Provider>
}

export function useConceptContext() {
  return React.useContext(ConceptContext)
}
